import { ISideNavLinks } from "lib/helpers/constants/sideNavLinks";
import { usePermissions } from "lib/hooks/shared/usePermissions";

export const hasChildrenWithPermissions = (children: ISideNavLinks[] | undefined): boolean => {
  if (!children) return false;
  return children.some(child => usePermissions(child.permissions || []));
};
